import { Video, XCircle, CheckCircle, Slash, MoreHorizontal } from 'react-feather'

import { ConsultationStatus } from '@/core/graphql/types'
import { IconText } from '@/components/ui/IconText'

import { getBgColorByStatus, getConsultationStatusLabel, getTextColorByStatus } from '../lib/consultationStatus'

function getStatusIcon(status: ConsultationStatus) {
  switch (status) {
    case ConsultationStatus.Accepted:
    case ConsultationStatus.Active:
    case ConsultationStatus.Completed:
      return <CheckCircle size={14} />
    case ConsultationStatus.Scheduled:
      return <Video size={14} /> // Or Clock?
    case ConsultationStatus.Canceled:
      return <Slash size={14} />
    case ConsultationStatus.Refused:
      return <XCircle size={14} />
    default:
      return <MoreHorizontal size={14} />
  }
}

export function ConsultationStatusBadge({ status }: { status: ConsultationStatus }) {
  return (
    <IconText
      icon={getStatusIcon(status)}
      text={getConsultationStatusLabel(status)}
      className={`rounded-md ${getBgColorByStatus(status)} px-2 py-1 font-medium ${getTextColorByStatus(status)}`}
      data-testid={`consultation-status-${status}`}
    />
  )
}
